import { Link } from 'react-router-dom';
import ZipliningImage from './assets/ziplining.jpg';

function ZipliningPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage ziplining-hero">
        <div className="hero-content">
          <h1>Ebamba's Thrilling Cape Town Ziplining</h1>
          <p>Fly through scenic valleys and forests with exhilarating zipline adventures.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Adventure Above the Treetops</h2>
          <div className="content-intro">
            <img src={ZipliningImage} alt="Ziplining Cape Town" className="tour-main-image" />
            <p>Get your adrenaline pumping with Ebamba Travel & Tours' ziplining adventures near Cape Town. Soar across breathtaking landscapes, over valleys, and through lush forests, experiencing incredible speed and panoramic views. We partner with top-rated zipline operators to ensure safety, excitement, and unforgettable memories.</p>
            <p>Perfect for families, groups, or solo thrill-seekers, ziplining offers a unique way to appreciate the natural beauty of the Western Cape. Choose from various locations offering different lengths and heights of ziplines, all promising an exhilarating ride and spectacular vistas.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Ziplining Adventure</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-helmet-safety"></i>
              <h4>Safety First</h4>
              <p>Comprehensive safety briefings and top-tier equipment provided, with experienced guides overseeing every step.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-bolt"></i>
              <h4>Exhilarating Rides</h4>
              <p>Experience the thrill of flying at high speeds across multiple zipline cables, varying in length and height.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-tree"></i>
              <h4>Stunning Natural Scenery</h4>
              <p>Enjoy unique perspectives of fynbos, mountains, valleys, and rivers as you glide through the air.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-users-line"></i>
              <h4>Fun for All Ages</h4>
              <p>Suitable for a wide range of ages and fitness levels, making it a great group activity.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Zipliners</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The ziplining tour was an absolute blast! So much fun, and the views were incredible. Ebamba helped us pick the perfect spot for our group."</p>
              <span>– Mark R. from USA</span>
            </div>
            <div className="testimonial-card">
              <p>"Totally exhilarating! I felt completely safe and had the time of my life soaring through the trees. Highly recommend this adventure through Ebamba."</p>
              <span>– Sarah J. from UK</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Ziplining Thrill</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ZipliningPage;
